import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { TabContent, TabPane, Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import ModalImage from "react-modal-image";
import moment from "moment";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { QRCodeSVG } from "qrcode.react";
import CountUp from "react-countup";
import CurrencyInput from "react-currency-input-field";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { resetLegalState, getLegal } from "../../../store/legal/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { resetLegalStatusState, getLegalStatus } from "../../../store/legalStatus/action";
import { resetLegalFractionState, getLegalFraction as onGetLegalFractions, addNewLegalFraction as onAddNewLegalFraction, updateLegalFraction as onUpdateLegalFraction, deleteLegalFraction as onDeleteLegalFraction, getLegalFractionLoading, resetLegalFractionCreateState } from "../../../store/legalFraction/action";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { resetClientState, getClient } from "../../../store/client/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
//import PrintDoc from "./PrintDoc";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { ButtonPrintF4, PrintDocF4 } from "./PrintDocF4";
import PrintDoc from "../../Task/PrintDoc";
import { getLegalMaster, getProductVarian, resetLegalMasterState, resetProductVarianState, setBranchSelect, setCompanySelect } from "../../../store/actions";

const LegalFraction = (props) => {
  const filerIdRef = useRef({
    branchId: 1,
  });
  const [pageIdx, setPageIdx] = useState(0);
  const [legalFractionalityDoc, setLegalFractionityDoc] = useState([]);
  const { t } = props;
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [activeCategoryTab, setActiveCategoryTab] = useState("all");
  const [indexPage, setIndexPage] = useState(0);
  const [placeValue, setPlaceValue] = useState("");
  const [legalMasterList, setLegalMasterList] = useState([]);
  const [locationCord, setLocationCord] = useState([-6.4577368, 106.9776222]);
  const [searchValue, setSearchValue] = useState("");
  const [modalAccPayable, setModalAccPayable] = useState(false);

  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, legalMasters, legalMasterLoading, legalFractions,
    legalFractionalAdded, isLegalFractionCreated, isLegalFractionSuccess, loading, error, legals, legalLoading, companies, companyLoading,
    clients, clientLoading, departments, departmentLoading, branches, branchLoading, legalStatus, legalStatusLoading,
    productVarians, productVarianLoading, budgets, budgetLoading } = useSelector((state) => ({
      clientSelected: state.App.clientSelected,
      companySelected: state.App.companySelected,
      branchSelected: state.App.branchSelected,
      userData: state.App.userData,
      userRole: state.App.userRole,
      userType: state.App.userType,
      legalFractionalAdded: state.LegalFraction.legalFractionalAdded,
      legalFractions: state.LegalFraction.legalFractions,
      loading: state.LegalFraction.loading,
      isLegalFractionCreated: state.LegalFraction.isLegalFractionCreated,
      isLegalFractionSuccess: state.LegalFraction.isLegalFractionSuccess,
      error: state.LegalFraction.error,
      companies: state.Company.companies,
      companyLoading: state.Company.loading,
      departments: state.Department.departments,
      departmentLoading: state.Department.loading,
      legalStatus: state.LegalStatus.legalStatus,
      legalStatusLoading: state.LegalStatus.loading,
      legals: state.Legal.legals,
      legalLoading: state.Legal.loading,
      legalMasters: state.LegalMaster.legalMasters,
      legalMasterLoading: state.LegalMaster.loading,
      branches: state.Branch.branches,
      branchLoading: state.Branch.loading,
      budgets: state.Budget.budgets,
      budgetLoading: state.Budget.loading,
      clients: state.Client.clients,
      clientLoading: state.Client.loading,
      productVarians: state.ProductVarian.productVarians,
      productVarianLoading: state.ProductVarian.loading,
    }));

  const [detailType, setDetailType] = useState(null);

  const [legalProgressNotaryList, setLegalProgressNotaryList] = useState([]);
  const [legalFractionalList, setLegalFractionList] = useState([]);
  const [legalFractional, setLegalFraction] = useState([]);
  const [legalProgressBNList, setLegalProgressBNList] = useState([]);
  const [legalKendalaList, setLegalKendalaList] = useState([]);
  const [legalFractionalUpdate, setLegalFractionUpdate] = useState(null);
  const [info, setInfo] = useState([]);
  const [assetFiles, setAssetFiles] = useState([]);
  const [profileFiles, setProfileFiles] = useState([]);
  const [detailFiles, setDetailFiles] = useState([]);

  const [isExportCSV, setIsExportCSV] = useState(false);
  const [budgetList, setBudgetList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();

  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [currentImage, setCurrentImage] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(false);

  const [departmentData, setUserData] = useState(null);
  const [legalStatusList, setLegalStatusList] = useState([]);
  const [legalProgressList, setLegalProgressList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");

  const [modalMedia, setModalMedia] = useState(false);
  const [docImg, setDocImg] = useState([]);
  const [checkDocumentList, setCheckDocumentList] = useState([]);
  const [searchBranch, setSearchBranch] = useState("");

  const [blockList, setBlockList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [branchIdSelected, setBranchIdSelected] = useState(null);

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const scrollRef = useRef(null);

  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);

  const handleMouseDown = (e) => {
    setIsDown(true);

    const rect = scrollRef.current.getBoundingClientRect();

    setStartX(e.clientX - rect.left);
    setStartY(e.clientY - rect.top);

    setScrollLeft(scrollRef.current.scrollLeft);
    setScrollTop(scrollRef.current.scrollTop);
  };

  const handleMouseLeave = () => {
    setIsDown(false);
  };

  const handleMouseUp = () => {
    setIsDown(false);
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;

    e.preventDefault();

    const rect = scrollRef.current.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const walkX = (x - startX) * 1.5; // speed horizontal
    const walkY = (y - startY) * 1.5; // speed vertical

    scrollRef.current.scrollLeft = scrollLeft - walkX;
    scrollRef.current.scrollTop = scrollTop - walkY;
  };

  const [customverticalTab, setcustomverticalTab] = useState("4");
  const customtoggleVertical = (tab) => {
    if (customverticalTab !== tab) {
      setcustomverticalTab(tab);
    }
  };

  const toggleTab = (tab, type, category) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      setActiveCategoryTab(category);
      let filteredLegalFractions = legalFractions;
      if (type !== "all") {
        if (category === "progress")
          filteredLegalFractions = legalFractions.filter((legalFractional) => (legalFractional.statusLegalProgressId ?? "").toString() === type.toString());
        else
          filteredLegalFractions = legalFractions.filter((legalFractional) => (legalFractional.statusLegalId ?? "").toString() === type.toString());
      }
      setLegalFractionList(filteredLegalFractions);
    }
  };

  useEffect(() => {
    if (branchSelected) {
      setBranchIdSelected(branchSelected.value);
      setPositionMessage(`${userData?.user.user_user && userData?.user.user_user.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      handleGetLegalFraction(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected]);

  const handleGetLegalFraction = (id, branchId) => {
    dispatch(resetLegalFractionState());
    dispatch(onGetLegalFractions(branchId ? { companyId: id, branchId: branchId } : { companyId: id, ...filerIdRef.current }));
    handleGetProductVariant(id);
    handleGetDepartment(id);
    handleGetLegalStatus();
    handleGetLegalMaster(id);
    handleGetBudget(id, branchId);
  };

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  const handleGetLegalMaster = (id) => {
    dispatch(resetLegalMasterState());
    dispatch(getLegalMaster({ companyId: id }));
  };

  const handleGetDepartment = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  const handleGetLegalStatus = () => {
    dispatch(resetLegalStatusState());
    dispatch(getLegalStatus({ type: "pecahan" }));
  };

  const handleGetProductVariant = (companyId) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, type: "referral" }));
  };

  useEffect(() => {
    if (!isEmpty(legalFractions)) {
      let filteredLegalFractions = legalFractions.data || legalFractions;
      if (activeTypeTab !== "all") {
        filteredLegalFractions = (legalFractions.data || legalFractions || []).filter((legalFractional) => legalFractional.lf_status_legal.id.toString() === activeTypeTab.toString());
      }

      setLegalFractionList(filteredLegalFractions.map((el) => ({ ...el, isChecked: false })));
      const data = filteredLegalFractions[filteredLegalFractions.length - 1];
      if (info.id) {
        for (const obj of filteredLegalFractions) {
          if (obj.id === info.id) {
            setInfo(obj);
            setLocationCord([obj?.latitude, obj?.longitude]);
          }
        }
      } else {
        setInfo(data);
        setLocationCord([data?.latitude, data?.longitude]);
      }
    }
  }, [legalFractions]);

  useEffect(() => {
    if (!isEmpty(productVarians)) {
      var productVarianData = [];
      var blockData = [];
      var opt = [];
      var block = [];
      productVarians.forEach((item) => {
        const varian = item.pvar_product;
        const blck = varian.product_block ? varian.product_block.id : "-";
        const blck_name = varian.product_block ? varian.product_block.name : "-";
        const name = blck_name + "-" + varian.name;
        const id = item.id;
        const barcode = item.barcode;
        const sku = item.sku;
        const brandId = item.brandId;
        const productId = item.productId;
        const branch = varian.branchId ? varian.branchId : "-";

        if (item.typeId === 1) {
          if (branchIdSelected === branch) {
            opt.push({ label: name, name: name, barcode: barcode, sku: sku, value: productId, brandId: brandId, productId: productId, productVarianId: id });
            const dataBlock = block.find((d) => d.value === blck);
            if (!dataBlock) block.push({ label: blck_name, value: blck });

            if (item.land_excess > 0) {
              opt.push({ label: name + 'A', name: name + 'A', barcode: barcode, sku: sku, value: productId, brandId: brandId, productId: productId, productVarianId: id });
              const dataBlock = block.find((d) => d.value === blck);
              if (!dataBlock) block.push({ label: blck_name, value: blck });
            }
          }
        }
      });

      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      productVarianData.push(option);
      setProductList(productVarianData);

      var option_block = { options: block.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      blockData.push(option_block);
      setBlockList(blockData);
    }
  }, [productVarians, branchIdSelected]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "NAMA",
        isSelected: true,
        data: [],
      },
      {
        id: "luas",
        label: "LUAS",
        isSelected: true,
        data: [],
      },
      {
        id: "njop",
        label: "HARGA",
        isSelected: true,
        data: [],
      },

      {
        id: "description",
        label: "KETERANGAN",
        isSelected: true,
        data: [],
      },
    ];

    if (legalFractionalList.length > 0) {
      legalFractionalList.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "code");
          if (doc) doc.data.push(data.code);

          doc = dataDoc.find((d) => d.id === "name");
          if (doc) doc.data.push(data.name);

          doc = dataDoc.find((d) => d.id === "luas");
          if (doc) doc.data.push(data.luas);

          doc = dataDoc.find((d) => d.id === "owner");
          if (doc) doc.data.push(data.owner);

          doc = dataDoc.find((d) => d.id === "quantity");
          if (doc) doc.data.push(data.quantity ?? 0);

          doc = dataDoc.find((d) => d.id === "njop");
          if (doc) doc.data.push(data.njop ?? 0);

          doc = dataDoc.find((d) => d.id === "price");
          if (doc) doc.data.push(data.price ?? 0);

          doc = dataDoc.find((d) => d.id === "description");
          if (doc) doc.data.push(data.description);
        }
      });
    }

    setLegalFractionityDoc(dataDoc);
  }, [legalFractionalList]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(branches)) {
      var data = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBranchList(data);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + ' - ' + item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  useEffect(() => {
    if (filerIdRef.current && branchList.length > 0) {
      const branchSelectedDefault = branchList[0].options.find((data) => data.value === filerIdRef.current.branchId);
      setSearchBranch(branchSelectedDefault);
    }
  }, [branchList]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var data = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
    }

    if (departments.length > 0) {
      setDepartmentList(data);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(legalStatus)) {
      var pecahan = [];
      var progresspecahan = [];
      var optprogresspecahan = [];
      var optpecahan = [];
      var progressnotaris = [];
      var optprogressnotaris = [];
      var progressbn = [];
      var optprogressbn = [];
      legalStatus.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        const type = item.type;
        var obj = { label: name, value: id, type: type };
        if (type === "pecahan")
          optpecahan.push(obj);
        if (type === "progresspecahan")
          optprogresspecahan.push(obj);
        if (type === "progressnotaris")
          optprogressnotaris.push(obj);
        if (type === "progressbn")
          optprogressbn.push(obj);
      });
      var optionpecahan = { options: optpecahan };
      pecahan.push(optionpecahan);

      var optionprogresspecahan = { options: optprogresspecahan };
      progresspecahan.push(optionprogresspecahan);

      var optionprogressnotaris = { options: optprogressnotaris };
      progressnotaris.push(optionprogressnotaris);

      var optionprogressbn = { options: optprogressbn };
      progressbn.push(optionprogressbn);

      setLegalStatusList(pecahan);
      setLegalProgressList(progresspecahan);
      setLegalProgressNotaryList(progressnotaris);
      setLegalProgressBNList(progressbn);
      setLegalKendalaList(legalStatus.filter(f => f.type === "kendala"))
    }

  }, [legalStatus]);

  const onClickDelete = (legalFractional) => {
    setLegalFraction(legalFractional);
    setDeleteModal(true);
  };

  const handleDeleteLegalFraction = () => {
    if (legalFractional) {
      dispatch(onDeleteLegalFraction(legalFractional));
      setDeleteModal(false);
    }
  };

  const toggleAccPayable = useCallback(() => {
    if (modalAccPayable) {
      setModalAccPayable(false);
    } else {
      setModalAccPayable(true);
    }
  }, [modalAccPayable]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setLegalFraction(null);
      setAssetFiles([]);
      setDocImg([]);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback(
    (type) => {
      if (modalDetail) {
        setModalDetail(false);
        setDetailType(null);
      } else {
        setModalDetail(true);
        setDetailType(type);
      }
    },
    [modalDetail]
  );

  const handleLegalFractionClick = useCallback((arg, type) => {
    const data = arg;

    let files = [];
    if (Array.isArray(data.image_3)) {
      for (const f of data.image_3) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
    }
    setAssetFiles(files);

    let m = data.bn_checklist ? data.bn_checklist.split(",") : [];
    setCheckDocumentList(m);

    setLegalFractionUpdate({
      id: data.id,
      branch: data.lf_branch && { label: data.lf_branch.name, value: data.lf_branch.id },
      company: data.lf_company && { label: data.lf_company.name, value: data.lf_company.id },
      client: data.lf_client && { label: data.lf_client.name, value: data.lf_client.id },
      lf_status_legal: data.lf_status_legal && {
        label: data.lf_status_legal.name,
        value: data.lf_status_legal.id,
      },
      lf_progress_legal: data.lf_progress_legal && {
        label: data.lf_progress_legal.name,
        value: data.lf_progress_legal.id,
      },
      lf_progress_notaris: data.lf_progress_notaris && {
        label: data.lf_progress_notaris.name,
        value: data.lf_progress_notaris.id,
      },
      lf_progress_bn: data.lf_progress_bn && {
        label: data.lf_progress_bn.name,
        value: data.lf_progress_bn.id,
      },
      legalmaster: data.legalmaster,
      land_size: data.land_size,
      name: data.name,
      productId: data.productId,
      behalf_company: data.behalf_company,
      behalf_customer: data.behalf_customer,
      targetat: data.targetat,
      description: data.description,
      mailing: data.mailing,
      isHook: data.isHook,
      nibel: data.nibel,
      hgb_pecahan: data.hgb_pecahan,
      no_check: data.no_check,
      id_billing: data.id_billing,
      checkat: data.checkat,
      no_check2: data.no_check2,
      id_billing2: data.id_billing2,
      checkat2: data.checkat2,
      berkas_bn: data.berkas_bn,
      takeajbat: data.takeajbat,
      bastbnat: data.bastbnat,
      bastbntrat: data.bastbntrat,
      bastbnfinishat: data.bastbnfinishat,
      bastofficeat: data.bastofficeat,
      backbnat: data.backbnat,
      bastbpnat: data.bastbpnat,
      bastbankat: data.bastbankat,
      bastbpnpendingat: data.bastbpnpendingat,
      baststfbankat: data.baststfbankat,
      phnat: data.phnat,
      phbpnat: data.phbpnat,
      takestfat: data.takestfat,
      takeimbat: data.takeimbat,
      nop: data.nop,
      desc_notary: data.desc_notary,
      noajbat: data.noajbat,
      salinanajbat: data.salinanajbat,
      salinabphtbat: data.salinabphtbat,
      book_bphtb: data.book_bphtb,
      book_pph: data.book_pph,
      no_akta: data.no_akta,
      hak: data.hak,
      code: data.code,
      picbn: data.picbn,
      desc_stf: data.desc_stf,
      followup: data.followup,
      termpay: data.termpay,
      termat: data.termat,
      picbnat: data.picbnat,
      nom_size: data.nom_size,
      desc_roya: data.desc_roya,
      kmk: data.kmk,
      desc_kendalabn: data.desc_kendalabn,
      dpp_hook: data.dpp_hook,
      pph: data.pph,
      bphtb: data.bphtb,
      jasa: data.jasa,
      desc_process: data.desc_process,
      notaris: data.notaris,
      desc_kendala: data.desc_kendala,
      desc_pph: data.desc_pph,
      desc_rika: data.desc_rika,
      sal_ajb: data.sal_ajb,
      sal_bphtb: data.sal_bphtb,
      desc_spsbn: data.desc_spsbn,
      bill_spsbn: data.bill_spsbn,
      spsbnat: data.spsbnat,
      desc_progres: data.desc_progres,
      progres: data.progres,
      desc_kendalaprogres: data.desc_kendalaprogres,
      followprogressat: data.followprogressat,
      no_ajb: data.no_ajb,
      lokasi_stf: data.lokasi_stf,
      bnat: data.bnat,
      image_1: data.image_1,
      image_2: data.image_2,
      image_3: data.image_3,
      image_4: data.image_4,
      image_5: data.image_5,
      image_6: data.image_6,
      image_7: data.image_7,
      bn_checklist: data.bn_checklist,
    });

    setIsEdit(true);
    toggle();
  },
    [toggle, legals]
  );

  const handleSalesClick = useCallback(
    (type) => {
      toggleDetail(type);
    },
    [toggleDetail, userType]
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = legalFractionalList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setLegalFractionList(updated);
    setIsCheckAll(allChecked);
  };

  const columns = useMemo(() => [{
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={legalFractionalList.find((x) => x.id === data.id).isChecked}
            onChange={() => {
              const updatedData = legalFractionalList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setLegalFractionList(updatedData);
            }}
          />
          <ButtonGroup className="me-1" >
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className="btn-sm"
                onClick={() => {
                  setInfo(data);
                  // setLocationCord([data.latitude, data.longitude]);
                }}
              >
                <i className="ri-eye-line fs-15"></i>
              </Button>
              <Button
                style={{ zIndex: '1' }}
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  handleLegalFractionClick(data);
                }}
              >
                <i className="ri-edit-2-line fs-15"></i>
              </Button>
            </UncontrolledButtonDropdown>
          </ButtonGroup>
        </div>
      );
    },
    id: "#",
  },
  {
    Header: "Proper",
    accessor: "lf_branch.name",
    filterable: true,
    Cell: (cellProps) => {
      const data = cellProps.row.original;
      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            setInfo(data);
          }}
        >
          <div className="mb-1">{data?.lf_branch?.name}</div>
          <div className="hstack gap-2">
            <span className="badge fw-normal fs-11" style={{ backgroundColor: data?.lf_progress_legal?.color, color: "#FFF" }}>
              {data?.lf_progress_legal?.name}
            </span>
          </div>
        </div>
      );
    },
  },
  {
    Header: "Blok",
    accessor: "name",
    filterable: true,
    Cell: (data) => <span className="fw-semibold">{data.value}</span>,
  },
  {
    id: "Kategori",
    Header: "Kategori",
    accessor: (data) => data?.lfp?.product_sales.length > 0 ? data?.lfp?.product_sales[0]?.sls_ds?.sales_type?.name : "",
    filterable: true,
  },
  {
    id: "PIC",
    Header: <div className="pe-3">PIC Notaris</div>,
    accessor: (data) => data?.lfp?.product_sales.length > 0 ? data?.lfp?.product_sales[0]?.sls_ds?.notaris : data?.notaris,
    filterable: true,
  },
  {
    id: "salinanajbat",
    Header: <div className="pe-3">Tanggal Salinan AJB</div>,
    accessor: "salinanajbat",
    filterable: true,
    Cell: (data) => <span className="fw-semibold">{handleValidDate(data.value)}</span>,
  },
  {
    id: "salinabphtbat",
    Header: <div className="pe-3">Tanggal Pengambilan STF</div>,
    accessor: "salinabphtbat",
    filterable: true,
    Cell: (data) => <span className="fw-semibold">{handleValidDate(data.value)}</span>,
  },
  {
    Header: "Catatan RIKA",
    accessor: "desc_rika",
    filterable: true,
    Cell: (data) => <span className="fw-semibold">{data.value}</span>,
  }],
    [legalFractionalList, handleLegalFractionClick, toggleHistory, userRole, userType, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = legalFractionalList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setLegalFractionList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => legalFractionalList, [legalFractionalList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Department"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      type: "requested",
      branchId: branchSelected?.value ?? "",
    };
    dispatch(onGetLegalFractions(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setLegalMasterList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    handleGetLegalFraction(companySelected?.value ?? "", branchSelected?.value ?? "");
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteLegalFraction(element.value));
    });
    checkall.checked = false;
  };

  function handleLegalFractionDetailAdd(type) {
    if (type === "profile") setProfileFiles([...profileFiles, { filename: "", originalname: "", description: "" }]);
    else setDetailFiles([...detailFiles, { filename: "", originalname: "", description: "" }]);
  }

  const handleSelectFile = (file) => {
    if (currentImage === "detail") {
      detailFiles[currentImageIndex].filename = file.filename;
      detailFiles[currentImageIndex].originalname = file.originalname;
    } else if (currentImage === "profile") {
      profileFiles[currentImageIndex].filename = file.filename;
      profileFiles[currentImageIndex].originalname = file.originalname;
    } else {
      setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    }
    setCurrentImage(null);
    setCurrentImageIndex(null);
    toggleMedia();
  };

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${fileName}-w-50`} large={`${api.MEDIA_URL}/media/${fileName}`} alt={info.name} className="img-thumbnail avatar-xs img-thumbnail user-profile-image" />;
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (legalFractionalUpdate && legalFractionalUpdate.id) || 0,
      company: (legalFractionalUpdate && legalFractionalUpdate.company) || companySelected,
      client: (legalFractionalUpdate && legalFractionalUpdate.client) || clientSelected,
      branch: (legalFractionalUpdate && legalFractionalUpdate.branch) || branchSelected,
      lf_status_legal: (legalFractionalUpdate && legalFractionalUpdate.lf_status_legal) ?? "",
      lf_progress_legal: (legalFractionalUpdate && legalFractionalUpdate.lf_progress_legal) ?? "",
      lf_progress_notaris: (legalFractionalUpdate && legalFractionalUpdate.lf_progress_notaris) ?? "",
      lf_progress_bn: (legalFractionalUpdate && legalFractionalUpdate.lf_progress_bn) ?? "",
      name: (legalFractionalUpdate && legalFractionalUpdate.name) ?? "",
      productId: (legalFractionalUpdate && legalFractionalUpdate.productId) ?? "",
      behalf_company: (legalFractionalUpdate && legalFractionalUpdate.behalf_company) ?? "",
      behalf_customer: (legalFractionalUpdate && legalFractionalUpdate.behalf_customer) ?? "",
      legalmaster: (legalFractionalUpdate && legalFractionalUpdate.legalmaster) || [],
      targetat: (legalFractionalUpdate && legalFractionalUpdate.targetat) ?? "",
      description: (legalFractionalUpdate && legalFractionalUpdate.description) ?? "",
      mailing: (legalFractionalUpdate && legalFractionalUpdate.mailing) || {},
      isHook: (legalFractionalUpdate && legalFractionalUpdate.isHook) || false,
      land_size: (legalFractionalUpdate && legalFractionalUpdate.land_size) || 0,
      nibel: (legalFractionalUpdate && legalFractionalUpdate.nibel) ?? "",

      hgb_pecahan: (legalFractionalUpdate && legalFractionalUpdate.hgb_pecahan) ?? "",
      no_check: (legalFractionalUpdate && legalFractionalUpdate.no_check) ?? "",
      id_billing: (legalFractionalUpdate && legalFractionalUpdate.id_billing) ?? "",
      checkat: (legalFractionalUpdate && legalFractionalUpdate.checkat) ?? "",
      no_check2: (legalFractionalUpdate && legalFractionalUpdate.no_check2) ?? "",
      id_billing2: (legalFractionalUpdate && legalFractionalUpdate.id_billing2) ?? "",
      checkat2: (legalFractionalUpdate && legalFractionalUpdate.checkat2) ?? "",
      berkas_bn: (legalFractionalUpdate && legalFractionalUpdate.berkas_bn) ?? "",
      takeajbat: (legalFractionalUpdate && legalFractionalUpdate.takeajbat) ?? "",
      bastbnat: (legalFractionalUpdate && legalFractionalUpdate.bastbnat) ?? "",
      bastbntrat: (legalFractionalUpdate && legalFractionalUpdate.bastbntrat) ?? "",
      bastbnfinishat: (legalFractionalUpdate && legalFractionalUpdate.bastbnfinishat) ?? "",
      bastofficeat: (legalFractionalUpdate && legalFractionalUpdate.bastofficeat) ?? "",
      backbnat: (legalFractionalUpdate && legalFractionalUpdate.backbnat) ?? "",
      bastbpnat: (legalFractionalUpdate && legalFractionalUpdate.bastbpnat) ?? "",
      bastbankat: (legalFractionalUpdate && legalFractionalUpdate.bastbankat) ?? "",
      bastbpnpendingat: (legalFractionalUpdate && legalFractionalUpdate.bastbpnpendingat) ?? "",
      baststfbankat: (legalFractionalUpdate && legalFractionalUpdate.baststfbankat) ?? "",
      phnat: (legalFractionalUpdate && legalFractionalUpdate.phnat) ?? "",
      phbpnat: (legalFractionalUpdate && legalFractionalUpdate.phbpnat) ?? "",
      takestfat: (legalFractionalUpdate && legalFractionalUpdate.takestfat) ?? "",
      takeimbat: (legalFractionalUpdate && legalFractionalUpdate.takeimbat) ?? "",
      nop: (legalFractionalUpdate && legalFractionalUpdate.nop) ?? "",
      desc_notary: (legalFractionalUpdate && legalFractionalUpdate.desc_notary) ?? "",
      noajbat: (legalFractionalUpdate && legalFractionalUpdate.noajbat) ?? "",
      salinanajbat: (legalFractionalUpdate && legalFractionalUpdate.salinanajbat) ?? "",
      salinabphtbat: (legalFractionalUpdate && legalFractionalUpdate.salinabphtbat) ?? "",
      book_bphtb: (legalFractionalUpdate && legalFractionalUpdate.book_bphtb) ?? "",
      book_pph: (legalFractionalUpdate && legalFractionalUpdate.book_pph) ?? "",
      no_akta: (legalFractionalUpdate && legalFractionalUpdate.no_akta) ?? "",
      hak: (legalFractionalUpdate && legalFractionalUpdate.hak) ?? "",
      code: (legalFractionalUpdate && legalFractionalUpdate.code) ?? "",
      picbn: (legalFractionalUpdate && legalFractionalUpdate.picbn) ?? "",
      desc_stf: (legalFractionalUpdate && legalFractionalUpdate.desc_stf) ?? "",
      followup: (legalFractionalUpdate && legalFractionalUpdate.followup) ?? "",
      termpay: (legalFractionalUpdate && legalFractionalUpdate.termpay) ?? "",
      termat: (legalFractionalUpdate && legalFractionalUpdate.termat) ?? "",
      picbnat: (legalFractionalUpdate && legalFractionalUpdate.picbnat) ?? "",
      nom_size: (legalFractionalUpdate && legalFractionalUpdate.nom_size) ?? "",
      desc_roya: (legalFractionalUpdate && legalFractionalUpdate.desc_roya) ?? "",
      kmk: (legalFractionalUpdate && legalFractionalUpdate.kmk) ?? "",
      desc_kendalabn: (legalFractionalUpdate && legalFractionalUpdate.desc_kendalabn) ?? "",
      dpp_hook: (legalFractionalUpdate && legalFractionalUpdate.dpp_hook) ?? "",
      pph: (legalFractionalUpdate && legalFractionalUpdate.pph) ?? "",
      bphtb: (legalFractionalUpdate && legalFractionalUpdate.bphtb) ?? "",
      jasa: (legalFractionalUpdate && legalFractionalUpdate.jasa) ?? "",
      desc_process: (legalFractionalUpdate && legalFractionalUpdate.desc_process) ?? "",
      notaris: (legalFractionalUpdate && legalFractionalUpdate.notaris) ?? "",
      desc_kendala: (legalFractionalUpdate && legalFractionalUpdate.desc_kendala) ?? "",
      desc_pph: (legalFractionalUpdate && legalFractionalUpdate.desc_pph) ?? "",
      desc_rika: (legalFractionalUpdate && legalFractionalUpdate.desc_rika) ?? "",
      sal_ajb: (legalFractionalUpdate && legalFractionalUpdate.sal_ajb) ?? "",
      sal_bphtb: (legalFractionalUpdate && legalFractionalUpdate.sal_bphtb) ?? "",
      desc_spsbn: (legalFractionalUpdate && legalFractionalUpdate.desc_spsbn) ?? "",
      bill_spsbn: (legalFractionalUpdate && legalFractionalUpdate.bill_spsbn) ?? "",
      spsbnat: (legalFractionalUpdate && legalFractionalUpdate.spsbnat) ?? "",
      desc_progres: (legalFractionalUpdate && legalFractionalUpdate.desc_progres) ?? "",
      progres: (legalFractionalUpdate && legalFractionalUpdate.progres) ?? "",
      desc_kendalaprogres: (legalFractionalUpdate && legalFractionalUpdate.desc_kendalaprogres) ?? "",
      followprogressat: (legalFractionalUpdate && legalFractionalUpdate.followprogressat) ?? "",
      no_ajb: (legalFractionalUpdate && legalFractionalUpdate.no_ajb) ?? "",
      lokasi_stf: (legalFractionalUpdate && legalFractionalUpdate.lokasi_stf) ?? "",

      image_1: (legalFractionalUpdate && legalFractionalUpdate.image_1) ?? "",
      image_2: (legalFractionalUpdate && legalFractionalUpdate.image_2) ?? "",
      image_3: (legalFractionalUpdate && legalFractionalUpdate.image_3) ?? "",
      image_4: (legalFractionalUpdate && legalFractionalUpdate.image_4) ?? "",
      image_5: (legalFractionalUpdate && legalFractionalUpdate.image_5) ?? "",
      image_6: (legalFractionalUpdate && legalFractionalUpdate.image_6) ?? "",
      image_7: (legalFractionalUpdate && legalFractionalUpdate.image_7) ?? "",
      bn_checklist: (legalFractionalUpdate && legalFractionalUpdate.bn_checklist) ?? "",
      bnat: (legalFractionalUpdate && legalFractionalUpdate.bnat) ?? "",
    },
    validationSchema: Yup.object({
      company: Yup.object().required("Silahkan isi Perusahaan").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      branch: Yup.object().required("Silahkan isi Cabang").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getLegalFractionLoading());
      if (isEdit) {
        let ele = document.querySelectorAll(".checked-method-all");
        let arrData = "";
        ele.forEach((ele) => {
          if (ele.checked === true) {
            arrData += ele.value + ",";
          }
        });

        let editSubmit = {
          id: values.id,
          statusLegalId: values.lf_status_legal.value,
          statusLegalProgressId: values.lf_progress_legal.value,
          statusLegalNotarisId: values.lf_progress_notaris.value,
          statusLegalBNId: values.lf_progress_bn.value,
          name: values.name,
          branchId: values.branch.value ?? null,
          companyId: values.company.value ?? null,
          clientId: values.client.value ?? null,
          productId: values.productId,
          behalf_company: values.behalf_company,
          behalf_customer: values.behalf_customer,
          targetat: values.targetat,
          description: values.description,
          mailing: values.mailing,
          nibel: values.nibel,
          land_size: values.land_size,
          isHook: values.isHook,

          hgb_pecahan: values.hgb_pecahan,
          no_check: values.no_check,
          id_billing: values.id_billing,
          checkat: values.checkat,
          no_check2: values.no_check2,
          id_billing2: values.id_billing2,
          checkat2: values.checkat2,
          berkas_bn: values.berkas_bn,
          takeajbat: values.takeajbat,
          bastbnat: values.bastbnat,
          bastbntrat: values.bastbntrat,
          bastbnfinishat: values.bastbnfinishat,
          bastofficeat: values.bastofficeat,
          backbnat: values.backbnat,
          bastbpnat: values.bastbpnat,
          bastbankat: values.bastbankat,
          bastbpnpendingat: values.bastbpnpendingat,
          baststfbankat: values.baststfbankat,
          phnat: values.phnat,
          phbpnat: values.phbpnat,
          takestfat: values.takestfat,
          takeimbat: values.takeimbat,
          nop: values.nop,
          desc_notary: values.desc_notary,
          noajbat: values.noajbat,
          salinanajbat: values.salinanajbat,
          salinabphtbat: values.salinabphtbat,
          book_bphtb: values.book_bphtb,
          book_pph: values.book_pph,
          no_akta: values.no_akta,
          hak: values.hak,
          code: values.code,
          picbn: values.picbn,
          desc_stf: values.desc_stf,
          followup: values.followup,
          termpay: values.termpay,
          termat: values.termat,
          picbnat: values.picbnat,
          nom_size: values.nom_size,
          desc_roya: values.desc_roya,
          kmk: values.kmk,
          desc_kendalabn: values.desc_kendalabn,
          dpp_hook: values.dpp_hook,
          pph: values.pph,
          bphtb: values.bphtb,
          jasa: values.jasa,
          desc_process: values.desc_process,
          notaris: values.notaris,
          desc_kendala: values.desc_kendala,
          desc_pph: values.desc_pph,
          desc_rika: values.desc_rika,
          sal_ajb: values.sal_ajb,
          sal_bphtb: values.sal_bphtb,
          desc_spsbn: values.desc_spsbn,
          bill_spsbn: values.bill_spsbn,
          spsbnat: values.spsbnat,
          desc_progres: values.desc_progres,
          progres: values.progres,
          desc_kendalaprogres: values.desc_kendalaprogres,
          followprogressat: values.followprogressat,
          no_ajb: values.no_ajb,
          lokasi_stf: values.lokasi_stf,

          image_1: values.image_1,
          image_2: values.image_2,
          image_3: assetFiles.length > 0 ? assetFiles : [],
          image_4: values.image_4,
          image_5: values.image_5,
          image_6: values.image_6,
          image_7: values.image_7,
          bn_checklist: arrData.slice(0, -1),
          bnat: values.bnat,
        };
        dispatch(onUpdateLegalFraction(editSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  const validationAccPayable = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: 0,
      account: "",
      cashflow: "",
      description: `TANAH DALAM PENGEMBANGAN ${info?.legal_nominatif?.nama + " - " + info?.name}`,
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount"),
      cashflow: Yup.object().required("Silahkan isi Anggaran Cashflow").nullable(true)
    }),
    onSubmit: (values) => {
      dispatch(getLegalFractionLoading());
      info.setAccPayable = true;
      info.setApprove = false;
      info.transactionat = values.transactionat;
      info.budgetId = values.cashflow.value;
      info.accType = "PAYABLE";
      info.description = values.description;
      info.amount = values.amount;
      dispatch(onUpdateLegalFraction(info));
      validationAccPayable.resetForm();
      toggleAccPayable();
    },
  });

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = assetFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setAssetFiles(newState);
    } else {
      const index = assetFiles.findIndex((fl) => fl.filename === file.filename);
      setAssetFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  useEffect(() => {
    if (!isEmpty(legalMasters)) {
      var data = [];
      var opt = [{ label: "Select All", value: "all" }];
      legalMasters.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = {
          label: name,
          value: id,
        };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);

      setLegalMasterList(data);
    }
  }, [legalMasters]);

  document.title = "Salinan AJB | Enterprise Resources Planning";

  return (
    <>
      <div className="page-content">
        <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={legalFractionalList} />
        <DeleteModal show={deleteModal} onDeleteClick={handleDeleteLegalFraction} onCloseClick={() => setDeleteModal(false)} />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid>
          <BreadCrumb title="Notaris" pageTitle="Sub Notaris - Salinan ajb" loading={loading}>
            <div className="flex-shrink-0">
              <ExportDoc data={legalFractionalityDoc} />
            </div>
          </BreadCrumb>
          <Row>

            <Col sm={12}>
              <div className="hstack gap-3">
                {legalStatus.filter(f => f.type === 'progresspecahan').map((o, i) => (
                  <div key={i}
                    className="card align-items-center card-animate px-3 py-2"
                    style={activeTab === i + 2 && activeCategoryTab === "progress" ? { borderBottom: "3px solid #FFCC00", width: 100 / 9 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" } : { borderBottom: "2px solid #CCCCCC", width: 100 / 9 + "%", cursor: "pointer", minHeight: "30px", verticalAlign: "middle" }}
                    onClick={() => {
                      toggleTab(i + 2, o.id, "progress");
                    }}
                  >
                    <div className="d-flex align-items-center mb-2">
                      <div className="flex-shrink-0 avatar-xs me-2">
                        <div className={activeTab === i + 2 && activeCategoryTab === "progress" ? "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-soft-info" : "avatar-title fw-semibold rounded-circle fs-12 text-dark bg-light"}>{legalFractionalList.filter(f => f.statusLegalProgressId === o.id).length}</div>
                      </div>
                    </div>
                      <div className="fs-10 text-center text-wrap text-break">{o.name}</div>
                  </div>

                ))}

              </div>
            </Col>
            <Col lg={12}>
              <Card>
                <CardBody className="pt-0 pb-0">
                  <div>
                    <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                      <NavItem>
                        <NavLink
                          className={activeTab === "1" ? "fw-semibold px-2 active" : "px-2"}
                          onClick={() => {
                            toggleTab("1", "all", "none");
                          }}
                          href="#"
                        >
                          <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> ALL
                        </NavLink>
                      </NavItem>
                      {legalStatus.filter(f => f.type === 'pecahan').map((o, i) => (
                        <NavItem key={i}>
                          <NavLink
                            className={activeTab === i + 2 && activeCategoryTab === "none" ? "fw-semibold px-2 active" : "px-2"}
                            onClick={() => {
                              toggleTab(i + 2, o.id, "none");
                            }}
                            href="#"
                          >
                            <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> {o.name}
                          </NavLink>
                        </NavItem>
                      ))}
                    </Nav>
                    <Row className="mb-0">
                      <CardBody className="pb-0">
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-3 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={9}>
                            <div className="search-box me-2 mb-3 d-inline-block col-12">
                              <input
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                onChange={(e) => {
                                  setLegalFractionList(legalFractions.map((el) => ({ ...el, isChecked: false })));
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                placeholder={`${countSearch} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg={9}>
              <Card>
                <CardBody>
                  <div>
                    <div
                      className="table-responsive table-card table-container-sticky mb-1 table-scroll"
                      ref={scrollRef}
                      onMouseDown={handleMouseDown}
                      onMouseLeave={handleMouseLeave}
                      onMouseUp={handleMouseUp}
                      onMouseMove={handleMouseMove}
                      // style={{ cursor: isDown ? "grabbing" : "grab", userSelect: isDown ? "none" : "auto" }}
                      style={{
                        overflow: "auto",
                        maxHeight: "calc(100vh - 340px)",
                        cursor: isDown ? "grabbing" : "grab",
                        //userSelect: isDown ? "none" : "auto",
                      }}
                    >
                      <Table hover {...getTableProps()} className="align-middle table-nowrap table-fixed-header">
                        <thead >
                          {headerGroups.map((headerGroup, index) => (
                            <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                              {headerGroup.headers.map((column, index) => (
                                <th key={index} {...column.getSortByToggleProps()}>
                                  {column.render("Header")}
                                  {generateSortingIndicator(column)}
                                  {/* <Filter column={column} /> */}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <Fragment key={row.getRowProps().key}>
                                <tr>
                                  {row.cells.map((cell, index) => {
                                    return (
                                      <td {...cell.getCellProps()} key={index}>
                                        {cell.render("Cell")}
                                      </td>
                                    );
                                  })}
                                </tr>
                              </Fragment>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>

                    <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                      <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                      <Col className="col-md-auto">
                        <div className="d-flex gap-1">
                          <Button
                            className="btn btn-light"
                            onClick={() => {
                              setPageIdx(pageIndex - 1);
                              previousPage();
                            }}
                            disabled={!canPreviousPage}
                          >
                            {"<"}
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-md-auto d-none d-md-block">
                        Halaman {pageIndex + 1} dari {pageOptions.length}
                      </Col>
                      <Col className="col-md-auto">
                        <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                      </Col>
                      <Col className="col-md-auto">
                        <div className="d-flex gap-1">
                          <Button
                            className="btn btn-light"
                            onClick={() => {
                              setPageIdx(pageIndex + 1);
                              nextPage();
                            }}
                            disabled={!canNextPage}
                          >
                            {">"}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <Modal id="showModal" isOpen={modal} centered size="xl">
                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                      DATA SALINAN AJB
                    </ModalHeader>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}>
                      <ModalBody>
                        <Row>
                          <Col md={3}>
                            <Nav pills className="nav nav-pills flex-column nav-pills-tab custom-verti-nav-pills text-center">
                              <NavItem>
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({
                                    "mb-2": true,
                                    active: customverticalTab === "4",
                                  })}
                                  onClick={() => {
                                    customtoggleVertical("4");
                                  }}
                                  id="custom-v-pills-messages-tab">
                                  SALINAN AJB
                                </NavLink>
                              </NavItem>
                            </Nav>
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="client"
                                  value={validation.values.client}
                                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                                  placeholder="Pilih Grup Usaha"
                                  onChange={(e) => {
                                    validation.setFieldValue("client", e);
                                  }}
                                  options={clientList}></Select>
                                <div
                                  className="position-absolute"
                                  style={{
                                    top: "12px",
                                    left: "-24px",
                                  }}>
                                  {clientLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validation.touched.client && validation.errors.client && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.client}
                                </p>
                              )}
                            </div>
                            <div className="mb-3">
                              <div className="position-relative">
                                <Select
                                  name="company"
                                  value={validation.values.company}
                                  placeholder="Pilih Perusahaan"
                                  isDisabled={userType === "admin" || userType === "client" ? false : true}
                                  onChange={(e) => {
                                    dispatch(setBranchSelect(null));
                                    dispatch(setCompanySelect(e));
                                    validation.setFieldValue("company", e);
                                  }}
                                  options={companyList}></Select>
                                <div
                                  className="position-absolute"
                                  style={{
                                    top: "12px",
                                    left: "-24px",
                                  }}>
                                  {companyLoading && (
                                    <Spinner color="primary" size="sm">
                                      Loading...
                                    </Spinner>
                                  )}
                                </div>
                              </div>
                              {validation.touched.company && validation.errors.company && (
                                <p className="invalid-feedback d-block" type="invalid">
                                  {validation.errors.company}
                                </p>
                              )}
                            </div>
                            <div className="mb-3">
                              <Select
                                name="branch"
                                value={validation.values.branch}
                                placeholder="Pilih Proyek"
                                onChange={(e) => {
                                  dispatch(setBranchSelect(e));
                                  validation.setFieldValue("branch", e);
                                }}
                                options={branchList}
                              ></Select>
                              {validation.touched.branch && validation.errors.branch && <p className="text-error">{validation.errors.luas}</p>}
                            </div>
                            <div className="mb-3 mt-3 border-top pt-3 d-flex justify-content-between">
                              <Label htmlFor="taskFiles" className="form-label me-3">
                                Dokumen
                              </Label>
                              <button
                                type="button"
                                className="btn btn-sm btn-label btn-soft-success"
                                onClick={() => {
                                  toggleMedia();
                                }}
                              >
                                <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                              </button>
                            </div>
                            {assetFiles.map((assetFile, i) => {
                              if (assetFile.isDeleted) {
                                return null;
                              } else {
                                return (
                                  <div key={i} className="border-bottom mb-3" onClick={() => {
                                    const typeFile = assetFile.filename.split(".");
                                    if (typeFile[typeFile.length - 1] === "x-compressed") {
                                      window.open(`${api.MEDIA_URL}/media/${assetFile.filename}`);
                                    } else if (typeFile[typeFile.length - 1] === "sheet") {
                                      window.open(`${api.MEDIA_URL}/media/${assetFile.filename}`);
                                    } else if (typeFile[typeFile.length - 1] === "pdf") {
                                      window.open(`${api.MEDIA_URL}/media/${assetFile.filename}`);
                                    } else {
                                      //
                                    }
                                  }}>
                                    <div className="d-flex cursor-pointer justify-content-between mb-3 align-items-center">
                                      <div className="me-2 filelist-icon">
                                        <span className="fs-20 text-info">{renderIcon(assetFile.filename)}</span>
                                      </div>
                                      <div className="text-truncate">{assetFile.originalname}</div>
                                      <div>
                                        <Link
                                          to="#"
                                          className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                          onClick={(e) => {
                                            handleDeleteFile(assetFile);
                                          }}
                                        >
                                          <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                        </Link>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </Col>
                          <Col md={9}>
                            <TabContent
                              activeTab={customverticalTab}
                              className="text-muted mt-4 mt-md-0"
                              id="v-pills-tabContent"
                            >
                              <TabPane tabId="1" id="v-pills-home">
                                <Row>
                                  <Col lg={5}>

                                    <div className="mb-3">
                                      <Label htmlFor="active-status" className="form-label">
                                        Dasar Induk
                                      </Label>
                                      <Select
                                        name="legalmaster"
                                        value={validation.values.legalmaster}
                                        placeholder="Induk"
                                        isMulti
                                        onChange={(opt, { option }) => {
                                          let newOpts = opt;
                                          if (option && option.value === "all") {
                                            let filteredOptions = clone(legalMasterList);
                                            filteredOptions = filteredOptions[0].options.filter((filteredOption) => !newOpts.includes(filteredOption));
                                            newOpts = newOpts.concat(filteredOptions).filter((newOpt) => newOpt.value !== "all");
                                          }
                                          validation.setFieldValue("legalmaster", newOpts);
                                        }}
                                        options={legalMasterList}
                                      ></Select>
                                      {validation.touched.legalmaster && validation.errors.legalmaster && <p className="text-error">{validation.errors.legalmaster}</p>}
                                    </div>
                                    <div className="mb-3 col-lg-12">
                                      <Label htmlFor="active-status" className="form-label">
                                        Jenis Pecahan
                                      </Label>
                                      <Select
                                        name="lf_status_legal"
                                        value={validation.values.lf_status_legal}
                                        placeholder="Pilih Status"
                                        onChange={(e) => {
                                          validation.setFieldValue("lf_status_legal", e);
                                        }}
                                        options={legalStatusList} ></Select>
                                    </div>
                                    <div className="mb-1">
                                      <Input name="isHook" id="isHook-field" className="form-check-input" type="checkbox" onChange={validation.handleChange} onBlur={validation.handleBlur} checked={validation.values.isHook} /> &nbsp;
                                      <Label htmlFor="isHook-field" className="form-label">
                                        Jenis Pecahan Adalah Tanah Hook
                                      </Label>
                                    </div>
                                    <div className="mb-3 col-lg-12">
                                      <Label htmlFor="active-status" className="form-label">
                                        Progress Sertifikat
                                      </Label>
                                      <Select
                                        name="lf_progress_legal"
                                        value={validation.values.lf_progress_legal}
                                        placeholder="Pilih Status"
                                        onChange={(e) => {
                                          validation.setFieldValue("lf_progress_legal", e);
                                        }}
                                        options={legalProgressList} ></Select>
                                    </div>

                                    <div className="row">
                                      <div className="mb-3 col-lg-8">
                                        <Label htmlFor="name-field" className="form-label">
                                          {t("Nama")}
                                        </Label>
                                        <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama Manual" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                                        {validation.touched.name && validation.errors.name && <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>}
                                      </div>
                                      <div className="mb-3 col-lg-4">
                                        <label className="form-label" htmlFor="land_size">
                                          Luas Tanah
                                        </label>
                                        <Input type="number" className="form-control" id="land_size" placeholder="isi luas tanah" name="land_size" value={validation.values.land_size || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("land_size", e.target.value)} />
                                      </div>
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="hgb_pecahan-field" className="form-label">
                                        HGB Pecahan
                                      </Label>
                                      <Input name="hgb_pecahan" id="hgb_pecahan-field" className="form-control" placeholder="Isi HGB Pecahan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.hgb_pecahan} invalid={validation.touched.hgb_pecahan && validation.errors.hgb_pecahan ? true : false} />
                                      {validation.touched.hgb_pecahan && validation.errors.hgb_pecahan ? <FormFeedback type="invalid">{validation.errors.hgb_pecahan}</FormFeedback> : null}
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="code-field" className="form-label">
                                        Kode Sertifikat
                                      </Label>
                                      <Input name="code" id="code-field" className="form-control" placeholder="Isi Kode Sertifikat" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code} invalid={validation.touched.code && validation.errors.code ? true : false} />
                                      {validation.touched.code && validation.errors.code ? <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> : null}
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="nibel-field" className="form-label">
                                        {t("NIB EL")}
                                      </Label>
                                      <Input name="nibel" id="nibel-field" className="form-control" placeholder="Isi NIB El" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.nibel ?? ""} invalid={validation.touched.nibel && validation.errors.nibel ? true : false} />
                                      {validation.touched.nibel && validation.errors.nibel && <FormFeedback type="invalid">{validation.errors.nibel}</FormFeedback>}
                                    </div>
                                  </Col>
                                  <Col lg={7}>
                                    <div className="row">
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="baststfbankat-field" className="form-label">
                                          Tgl Setor STF Ke Bank (Pemasangan HT)
                                        </Label>
                                        <Flatpickr
                                          name="baststfbankat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.baststfbankat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("baststfbankat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="bastbnat-field" className="form-label">
                                          Tgl Setor Notaris
                                        </Label>
                                        <Flatpickr
                                          name="bastbnat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.bastbnat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("bastbnat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="bastofficeat-field" className="form-label">
                                          Tgl Masuk Developer
                                        </Label>
                                        <Flatpickr
                                          name="bastofficeat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.bastofficeat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("bastofficeat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="backbnat-field" className="form-label">
                                          Tgl Pengembalian Ke Notaris
                                        </Label>
                                        <Flatpickr
                                          name="backbnat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.backbnat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("backbnat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="bastbntrat-field" className="form-label">
                                          Tgl Setor Notaris (TR ke BPN)
                                        </Label>
                                        <Flatpickr
                                          name="bastbntrat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.bastbntrat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("bastbntrat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="bastbpnpendingat-field" className="form-label">
                                          Tgl Pendingan BPN
                                        </Label>
                                        <Flatpickr
                                          name="bastbpnpendingat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.bastbpnpendingat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("bastbpnpendingat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="bastbpnat-field" className="form-label">
                                          Tgl Setor BPN
                                        </Label>
                                        <Flatpickr
                                          name="bastbpnat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.bastbpnat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("bastbpnat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="bastbankat-field" className="form-label">
                                          Tgl Setor Bank
                                        </Label>
                                        <Flatpickr
                                          name="bastbankat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.bastbankat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("bastbankat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="bastbnfinishat-field" className="form-label">
                                          Tanggal Selesai Balik Nama (HGB)
                                        </Label>
                                        <Flatpickr
                                          name="bastbnfinishat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.bastbnfinishat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("bastbnfinishat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="phnat-field" className="form-label">
                                          Tanggal PH ke Notaris
                                        </Label>
                                        <Flatpickr
                                          name="phnat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.phnat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("phnat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="phbpnat-field" className="form-label">
                                          Tanggal PH ke BPN
                                        </Label>
                                        <Flatpickr
                                          name="phbpnat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.phbpnat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("phbpnat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="hmfinishat-field" className="form-label">
                                          Tanggal Selesai HM
                                        </Label>
                                        <Flatpickr
                                          name="hmfinishat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.hmfinishat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("hmfinishat", e);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="mb-3 d-none">
                                      <Label htmlFor="targetat-field" className="form-label">
                                        Target
                                      </Label>
                                      <Flatpickr
                                        name="targetat"
                                        className="form-control"
                                        placeholder="Pilih Tanggal"
                                        options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                        value={validation.values.targetat ?? ""}
                                        onChange={(o, e) => {
                                          validation.setFieldValue("targetat", e);
                                        }}
                                      />
                                      {validation.touched.targetat && validation.errors.targetat ? (
                                        <p className="text-danger" type="invalid">
                                          {validation.errors.targetat}
                                        </p>
                                      ) : null}
                                    </div>
                                    <div className="mb-3 d-none">
                                      <Label htmlFor="behalf_company-field" className="form-label">
                                        Atas Nama PT
                                      </Label>
                                      <Input name="behalf_company" id="behalf_company-field" className="form-control" placeholder="Isi Atas Nama PT" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.behalf_company} invalid={validation.touched.behalf_company && validation.errors.behalf_company ? true : false} />
                                      {validation.touched.behalf_company && validation.errors.behalf_company ? <FormFeedback type="invalid">{validation.errors.behalf_company}</FormFeedback> : null}
                                    </div>
                                    <div className="mb-3 d-none">
                                      <Label htmlFor="behalf_customer-field" className="form-label">
                                        Atas Nama Konsumen
                                      </Label>
                                      <Input name="behalf_customer" id="behalf_customer-field" className="form-control" placeholder="Isi Atas Nama Pembeli" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.behalf_customer} invalid={validation.touched.behalf_customer && validation.errors.behalf_customer ? true : false} />
                                      {validation.touched.behalf_customer && validation.errors.behalf_customer ? <FormFeedback type="invalid">{validation.errors.behalf_customer}</FormFeedback> : null}
                                    </div>
                                    <div className="mb-3">
                                      <Label htmlFor="des-field" className="form-label">
                                        Keterangan
                                      </Label>
                                      <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                                    </div>

                                  </Col>
                                </Row>
                              </TabPane>
                              <TabPane tabId="2" id="v-pills-profile">
                                <div className="row">
                                  <div className="mb-3 col-lg-3">
                                    <Label htmlFor="takeajbat-field" className="form-label">
                                      Tanggal Pengambilan AJB
                                    </Label>
                                    <Flatpickr
                                      name="takeajbat"
                                      className="form-control"
                                      placeholder="Pilih Tanggal"
                                      options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                      value={validation.values.takeajbat ?? ""}
                                      onChange={(o, e) => {
                                        validation.setFieldValue("takeajbat", e);
                                      }}
                                    />
                                  </div>
                                  <div className="mb-3 col-lg-3">
                                    <Label htmlFor="takestfat-field" className="form-label">
                                      Tanggal Pengambilan STF
                                    </Label>
                                    <Flatpickr
                                      name="takestfat"
                                      className="form-control"
                                      placeholder="Pilih Tanggal"
                                      options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                      value={validation.values.takestfat ?? ""}
                                      onChange={(o, e) => {
                                        validation.setFieldValue("takestfat", e);
                                      }}
                                    />
                                  </div>

                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="active-status" className="form-label">
                                      Progress Sertifikat
                                    </Label>
                                    <Select
                                      name="lf_progress_legal"
                                      value={validation.values.lf_progress_legal}
                                      placeholder="Pilih Status"
                                      onChange={(e) => {
                                        validation.setFieldValue("lf_progress_legal", e);
                                      }}
                                      options={legalProgressList} ></Select>
                                  </div>

                                  <div className="mb-3 col-lg-4 d-none">
                                    <Label htmlFor="takeimbat-field" className="form-label">
                                      Tanggal Pengambilan IMB
                                    </Label>
                                    <Flatpickr
                                      name="takeimbat"
                                      className="form-control"
                                      placeholder="Pilih Tanggal"
                                      options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                      value={validation.values.takeimbat ?? ""}
                                      onChange={(o, e) => {
                                        validation.setFieldValue("takeimbat", e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-lg-12 mb-3">
                                    BAST dengan konsumen (KTP/Perwakilan Konsumen & Foto Konsumen/Perwakilan) wajib di scan dan di upload.
                                  </div>
                                </div>
                              </TabPane>
                              <TabPane tabId="3" id="v-pills-messages">
                                <Row>
                                  <Col md={7}>
                                    <div className="mb-3">
                                      <Label htmlFor="des-field" className="form-label">
                                        Keterangan Kendala BN
                                      </Label>
                                      <Input name="desc_kendala" id="des-field" className="form-control" placeholder="Isi Keterangan Kendala BN" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.desc_kendala ?? ""} />
                                    </div>
                                    <div className="row">
                                      <div className="mb-3 col-lg-8">
                                        <Label htmlFor="picbn-field" className="form-label">
                                          PIC Proses BN
                                        </Label>
                                        <Input name="picbn" id="picbn-field" className="form-control" placeholder="Isi PIC BN" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.picbn} invalid={validation.touched.picbn && validation.errors.picbn ? true : false} />
                                        {validation.touched.picbn && validation.errors.picbn ? <FormFeedback type="invalid">{validation.errors.picbn}</FormFeedback> : null}
                                      </div>
                                      <div className="mb-3 col-lg-4">
                                        <Label htmlFor="picbnat-field" className="form-label">
                                          Tanggal PIC BN
                                        </Label>
                                        <Flatpickr
                                          name="picbnat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.picbnat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("picbnat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="mb-3 col-lg-6">
                                        <Label htmlFor="notaris-field" className="form-label">
                                          PIC Notaris
                                        </Label>
                                        <Input name="notaris" id="notaris-field" className="form-control" placeholder="Isi Notaris" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.notaris} invalid={validation.touched.notaris && validation.errors.notaris ? true : false} />
                                        {validation.touched.notaris && validation.errors.notaris ? <FormFeedback type="invalid">{validation.errors.notaris}</FormFeedback> : null}
                                      </div>
                                    </div>

                                    <div className="row">
                                      <div className="mb-3 col-lg-8">
                                        <Label htmlFor="no_check-field" className="form-label">
                                          No Berkas Pengecekan 1
                                        </Label>
                                        <Input name="no_check" id="no_check-field" className="form-control" placeholder="Isi No Berkas Pengecekan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.no_check} invalid={validation.touched.no_check && validation.errors.no_check ? true : false} />
                                        {validation.touched.no_check && validation.errors.no_check ? <FormFeedback type="invalid">{validation.errors.no_check}</FormFeedback> : null}
                                      </div>
                                      <div className="mb-3 col-lg-4">
                                        <Label htmlFor="checkat-field" className="form-label">
                                          Tgl Pengecekan 1
                                        </Label>
                                        <Flatpickr
                                          name="checkat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.checkat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("checkat", e);
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="mb-3">
                                      <Label htmlFor="id_billing-field" className="form-label">
                                        ID Biling Pengecekan 1
                                      </Label>
                                      <Input name="id_billing" id="id_billing-field" className="form-control" placeholder="Isi ID Biling" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.id_billing} invalid={validation.touched.id_billing && validation.errors.id_billing ? true : false} />
                                      {validation.touched.id_billing && validation.errors.id_billing ? <FormFeedback type="invalid">{validation.errors.id_billing}</FormFeedback> : null}
                                    </div>


                                    <div className="row">
                                      <div className="mb-3 col-lg-8">
                                        <Label htmlFor="no_check2-field" className="form-label">
                                          No Berkas Pengecekan 2
                                        </Label>
                                        <Input name="no_check2" id="no_check2-field" className="form-control" placeholder="Isi No Berkas Pengecekan" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.no_check2} invalid={validation.touched.no_check2 && validation.errors.no_check2 ? true : false} />
                                        {validation.touched.no_check2 && validation.errors.no_check2 ? <FormFeedback type="invalid">{validation.errors.no_check2}</FormFeedback> : null}
                                      </div>
                                      <div className="mb-3 col-lg-4">
                                        <Label htmlFor="check2at-field" className="form-label">
                                          Tgl Pengecekan 2
                                        </Label>
                                        <Flatpickr
                                          name="check2at"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.check2at ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("check2at", e);
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="mb-3">
                                      <Label htmlFor="id_billing2-field" className="form-label">
                                        ID Biling Pengecekan 2
                                      </Label>
                                      <Input name="id_billing2" id="id_billing2-field" className="form-control" placeholder="Isi ID Biling" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.id_billing2} invalid={validation.touched.id_billing2 && validation.errors.id_billing2 ? true : false} />
                                      {validation.touched.id_billing2 && validation.errors.id_billing2 ? <FormFeedback type="invalid">{validation.errors.id_billing2}</FormFeedback> : null}
                                    </div>


                                  </Col>
                                  <Col md={5}>
                                    <div className="row">
                                      <div className="mb-3 col-lg-7">
                                        <Label htmlFor="no_ajb-field" className="form-label">
                                          No AJB
                                        </Label>
                                        <Input name="no_ajb" id="no_ajb-field" className="form-control" placeholder="Isi No Akta" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.no_ajb} invalid={validation.touched.no_ajb && validation.errors.no_ajb ? true : false} />
                                        {validation.touched.no_ajb && validation.errors.no_ajb ? <FormFeedback type="invalid">{validation.errors.no_ajb}</FormFeedback> : null}
                                      </div>

                                      <div className="mb-3 col-lg-5">
                                        <Label htmlFor="noajbat-field" className="form-label">
                                          Tanggal AJB
                                        </Label>
                                        <Flatpickr
                                          name="noajbat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.noajbat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("noajbat", e);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="mb-3 col-lg-7">
                                        <Label htmlFor="no_akta-field" className="form-label">
                                          Kode Akta
                                        </Label>
                                        <Input name="no_akta" id="no_akta-field" className="form-control" placeholder="Isi No Akta" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.no_akta} invalid={validation.touched.no_akta && validation.errors.no_akta ? true : false} />
                                        {validation.touched.no_akta && validation.errors.no_akta ? <FormFeedback type="invalid">{validation.errors.no_akta}</FormFeedback> : null}
                                      </div>
                                      <div className="mb-3 col-lg-5">
                                        <Label htmlFor="bnat-field" className="form-label">
                                          Tgl BN
                                        </Label>
                                        <Flatpickr
                                          name="bnat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.bnat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("bnat", e);
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="mb-3">
                                      <Label htmlFor="berkas_bn-field" className="form-label">
                                        No SPS BN
                                      </Label>
                                      <Input name="berkas_bn" id="berkas_bn-field" className="form-control" placeholder="Isi No Berkas BN" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.berkas_bn} invalid={validation.touched.berkas_bn && validation.errors.berkas_bn ? true : false} />
                                      {validation.touched.berkas_bn && validation.errors.berkas_bn ? <FormFeedback type="invalid">{validation.errors.berkas_bn}</FormFeedback> : null}
                                    </div>

                                    <div className="row">
                                      <div className="mb-3 col-lg-7">
                                        <Label htmlFor="bill_spsbn-field" className="form-label">
                                          Kode Billing SPS BN
                                        </Label>
                                        <Input name="bill_spsbn" id="bill_spsbn-field" className="form-control" placeholder="Isi Kode Billing SPS BN" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.bill_spsbn} invalid={validation.touched.bill_spsbn && validation.errors.bill_spsbn ? true : false} />
                                        {validation.touched.bill_spsbn && validation.errors.bill_spsbn ? <FormFeedback type="invalid">{validation.errors.bill_spsbn}</FormFeedback> : null}
                                      </div>

                                      <div className="mb-3 col-lg-5">
                                        <Label htmlFor="spsbnat-field" className="form-label">
                                          Tgl SPS BN
                                        </Label>
                                        <Flatpickr
                                          name="spsbnat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.spsbnat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("spsbnat", e);
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="mb-3">
                                      <Label htmlFor="desc_spsbn-field" className="form-label">
                                        Keterangan SPS BN
                                      </Label>
                                      <Input name="desc_spsbn" id="desc_spsbn-field" className="form-control" placeholder="Isi Keterangan SPS BN" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.desc_spsbn} invalid={validation.touched.desc_spsbn && validation.errors.desc_spsbn ? true : false} />
                                      {validation.touched.desc_spsbn && validation.errors.desc_spsbn ? <FormFeedback type="invalid">{validation.errors.desc_spsbn}</FormFeedback> : null}
                                    </div>
                                  </Col>

                                </Row>

                              </TabPane>

                              <TabPane tabId="4" id="v-pills-settings">
                                <div className="row">
                                  <div className="mb-3 col-lg-3">
                                    <Label htmlFor="salinanajbat-field" className="form-label">
                                      Tanggal Salinan AJB
                                    </Label>
                                    <Flatpickr
                                      name="salinanajbat"
                                      className="form-control"
                                      placeholder="Pilih Tanggal"
                                      options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                      value={validation.values.salinanajbat ?? ""}
                                      onChange={(o, e) => {
                                        validation.setFieldValue("salinanajbat", e);
                                      }}
                                    />
                                  </div>
                                  <div className="mb-3 col-lg-3">
                                    <Label htmlFor="salinabphtbat-field" className="form-label">
                                      Tanggal Salinan BPHTB
                                    </Label>
                                    <Flatpickr
                                      name="salinabphtbat"
                                      className="form-control"
                                      placeholder="Pilih Tanggal"
                                      options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                      value={validation.values.salinabphtbat ?? ""}
                                      onChange={(o, e) => {
                                        validation.setFieldValue("salinabphtbat", e);
                                      }}
                                    />
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="notaris-field" className="form-label">
                                      PIC Notaris
                                    </Label>
                                    <Input name="notaris" id="notaris-field" className="form-control" placeholder="Isi Notaris" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.notaris} invalid={validation.touched.notaris && validation.errors.notaris ? true : false} />
                                    {validation.touched.notaris && validation.errors.notaris ? <FormFeedback type="invalid">{validation.errors.notaris}</FormFeedback> : null}
                                  </div>
                                </div>
                                <div className="mb-3">
                                  <Label htmlFor="desc_rika-field" className="form-label">
                                    Catatan RIKA
                                  </Label>
                                  <Input name="desc_rika" id="desc_rika-field" className="form-control" placeholder="Isi Catatan RIKA" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.desc_rika} invalid={validation.touched.desc_rika && validation.errors.desc_rika ? true : false} />
                                  {validation.touched.desc_rika && validation.errors.desc_rika ? <FormFeedback type="invalid">{validation.errors.desc_rika}</FormFeedback> : null}
                                </div>
                              </TabPane>

                              <TabPane tabId="5" id="v-pills-settings">
                                <div className="row">
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="active-status" className="form-label">
                                      Progress Sertifikat
                                    </Label>
                                    <Select
                                      name="lf_progress_notaris"
                                      value={validation.values.lf_progress_notaris}
                                      placeholder="Pilih Status"
                                      onChange={(e) => {
                                        validation.setFieldValue("lf_progress_notaris", e);
                                      }}
                                      options={legalProgressNotaryList} ></Select>
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="notaris-field" className="form-label">
                                      PIC Notaris
                                    </Label>
                                    <Input name="notaris" id="notaris-field" className="form-control" placeholder="Isi Notaris" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.notaris} invalid={validation.touched.notaris && validation.errors.notaris ? true : false} />
                                    {validation.touched.notaris && validation.errors.notaris ? <FormFeedback type="invalid">{validation.errors.notaris}</FormFeedback> : null}
                                  </div>
                                  <div className="mb-3 col-lg-9">
                                    <Label htmlFor="desc_kendalaprogres-field" className="form-label">
                                      Keterangan Progress
                                    </Label>
                                    <Input name="desc_kendalaprogres" id="desc_kendalaprogres-field" className="form-control" placeholder="Isi Keterangan Progress" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.desc_kendalaprogres} invalid={validation.touched.desc_kendalaprogres && validation.errors.desc_kendalaprogres ? true : false} />
                                    {validation.touched.desc_kendalaprogres && validation.errors.desc_kendalaprogres ? <FormFeedback type="invalid">{validation.errors.desc_kendalaprogres}</FormFeedback> : null}
                                  </div>
                                  <div className="mb-3 col-lg-3">
                                    <Label htmlFor="followprogressat-field" className="form-label">
                                      Tanggal Followup
                                    </Label>
                                    <Flatpickr
                                      name="followprogressat"
                                      className="form-control"
                                      placeholder="Pilih Tanggal"
                                      options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                      value={validation.values.followprogressat ?? ""}
                                      onChange={(o, e) => {
                                        validation.setFieldValue("followprogressat", e);
                                      }}
                                    />
                                  </div>
                                </div>

                              </TabPane>
                              <TabPane tabId="6" id="v-pills-home">
                                <Row>
                                  <Col lg={12}>

                                    <div className="row">
                                      <div className="mb-3 col-lg-8">
                                        <Label htmlFor="name-field" className="form-label">
                                          Blok
                                        </Label>
                                        <Input name="name" id="name-field" className="form-control" placeholder="Isi Blok" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                                        {validation.touched.name && validation.errors.name && <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>}
                                      </div>
                                      <div className="mb-3 col-lg-4">
                                        <label className="form-label" htmlFor="land_size">
                                          Luas Tanah Sertifikat
                                        </label>
                                        <Input type="number" className="form-control" id="land_size" placeholder="isi luas tanah" name="land_size" value={validation.values.land_size || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("land_size", e.target.value)} />
                                      </div>

                                      <div className="mb-3 col-lg-8">
                                        <Label htmlFor="behalf_customer-field" className="form-label">
                                          Nama
                                        </Label>
                                        <Input name="behalf_customer" id="behalf_customer-field" className="form-control" placeholder="Isi Atas Nama Pembeli" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.behalf_customer} invalid={validation.touched.behalf_customer && validation.errors.behalf_customer ? true : false} />
                                        {validation.touched.behalf_customer && validation.errors.behalf_customer ? <FormFeedback type="invalid">{validation.errors.behalf_customer}</FormFeedback> : null}
                                      </div>
                                      <div className="mb-3 col-lg-4">
                                        <label className="form-label" htmlFor="land_excess">
                                          Luas Tanah Penjualan
                                        </label>
                                        <Input type="number" className="form-control" id="land_excess" placeholder="isi luas tanah" name="land_excess" value={validation.values.land_excess || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("land_excess", e.target.value)} />
                                      </div>
                                      <div className="mb-3 col-lg-8">
                                        <label className="form-label" htmlFor="termpay">
                                          Termin Pembayaran
                                        </label>
                                        <Input type="text" className="form-control" id="termpay" placeholder="isi luas tanah" name="termpay" value={validation.values.termpay || 0} onBlur={validation.handleBlur} onFocus={(e) => e.target.select()} onChange={(e) => validation.setFieldValue("termpay", e.target.value)} />
                                      </div>
                                      <div className="mb-3 col-lg-4">
                                        <Label htmlFor="termat-field" className="form-label">
                                          Tgl Termin Pembayaran
                                        </Label>
                                        <Flatpickr
                                          name="termat"
                                          className="form-control"
                                          placeholder="Pilih Tanggal"
                                          options={{ enableTime: false, dateFormat: "Y/m/d" }}
                                          value={validation.values.termat ?? ""}
                                          onChange={(o, e) => {
                                            validation.setFieldValue("termat", e);
                                          }}
                                        />
                                      </div>
                                      <div className="">Wajib upload termin pembayaran.</div>
                                    </div>
                                  </Col>
                                </Row>
                              </TabPane>


                              <TabPane tabId="7" id="v-pills-settings">
                                <div className="row">
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="name-field" className="form-label">
                                      Blok
                                    </Label>
                                    <Input name="name" id="name-field" className="form-control" placeholder="Isi Blok" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                                    {validation.touched.name && validation.errors.name && <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>}
                                  </div>

                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="behalf_customer-field" className="form-label">
                                      Nama
                                    </Label>
                                    <Input name="behalf_customer" id="behalf_customer-field" className="form-control" placeholder="Isi Atas Nama Pembeli" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.behalf_customer} invalid={validation.touched.behalf_customer && validation.errors.behalf_customer ? true : false} />
                                    {validation.touched.behalf_customer && validation.errors.behalf_customer ? <FormFeedback type="invalid">{validation.errors.behalf_customer}</FormFeedback> : null}
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="notaris-field" className="form-label">
                                      PIC Notaris
                                    </Label>
                                    <Input name="notaris" id="notaris-field" className="form-control" placeholder="Isi Notaris" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.notaris} invalid={validation.touched.notaris && validation.errors.notaris ? true : false} />
                                    {validation.touched.notaris && validation.errors.notaris ? <FormFeedback type="invalid">{validation.errors.notaris}</FormFeedback> : null}
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="picbn-field" className="form-label">
                                      PIC Proses BN
                                    </Label>
                                    <Input name="picbn" id="picbn-field" className="form-control" placeholder="Isi PIC BN" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.picbn} invalid={validation.touched.picbn && validation.errors.picbn ? true : false} />
                                    {validation.touched.picbn && validation.errors.picbn ? <FormFeedback type="invalid">{validation.errors.picbn}</FormFeedback> : null}
                                  </div>

                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="book_bphtb-field" className="form-label">
                                      No Booking BPHTB
                                    </Label>
                                    <Input name="book_bphtb" id="book_bphtb-field" className="form-control" placeholder="Isi Atas Nama Pembeli" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.book_bphtb} invalid={validation.touched.book_bphtb && validation.errors.book_bphtb ? true : false} />
                                    {validation.touched.book_bphtb && validation.errors.book_bphtb ? <FormFeedback type="invalid">{validation.errors.book_bphtb}</FormFeedback> : null}
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="book_pph-field" className="form-label">
                                      No Booking PPH
                                    </Label>
                                    <Input name="book_pph" id="book_pph-field" className="form-control" placeholder="Isi Atas Nama Pembeli" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.book_pph} invalid={validation.touched.book_pph && validation.errors.book_pph ? true : false} />
                                    {validation.touched.book_pph && validation.errors.book_pph ? <FormFeedback type="invalid">{validation.errors.book_pph}</FormFeedback> : null}
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="nop-field" className="form-label">
                                      NOP
                                    </Label>
                                    <Input name="nop" id="nop-field" className="form-control" placeholder="Isi Atas Nama Pembeli" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.nop} invalid={validation.touched.nop && validation.errors.nop ? true : false} />
                                    {validation.touched.nop && validation.errors.nop ? <FormFeedback type="invalid">{validation.errors.nop}</FormFeedback> : null}
                                  </div>

                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="active-status" className="form-label">
                                      Progress Balik Nama
                                    </Label>
                                    <Select
                                      name="lf_progress_bn"
                                      value={validation.values.lf_progress_bn}
                                      placeholder="Pilih Status"
                                      onChange={(e) => {
                                        validation.setFieldValue("lf_progress_bn", e);
                                      }}
                                      options={legalProgressBNList} ></Select>
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    {legalKendalaList.map((o, idx) => {
                                      return (
                                        <div key={idx} className="form-check form-switch form-switch-custom form-switch-success mb-3">
                                          <Input className={"form-check-input checked-all checked-method-all check-" + o.id + idx} type="checkbox" role="switch" id={"check-" + o.id + idx} value={o.id} defaultChecked={checkDocumentList.indexOf(o.id.toString()) !== -1 ? true : false} />
                                          <Label className="form-check-label text-dark text-uppercase" htmlFor={"check-" + o.id + idx}>
                                            {o.name}
                                          </Label>
                                        </div>
                                      );
                                    })}
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="desc_kendalaprogres-field" className="form-label">
                                      Keterangan Kendala
                                    </Label>
                                    <Input name="desc_kendalaprogres" id="desc_kendalaprogres-field" className="form-control" placeholder="Isi Keterangan Kendala" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.desc_kendalaprogres} invalid={validation.touched.desc_kendalaprogres && validation.errors.desc_kendalaprogres ? true : false} />
                                    {validation.touched.desc_kendalaprogres && validation.errors.desc_kendalaprogres ? <FormFeedback type="invalid">{validation.errors.desc_kendalaprogres}</FormFeedback> : null}
                                  </div>
                                </div>

                              </TabPane>
                            </TabContent>
                          </Col>
                        </Row>
                      </ModalBody>
                      <div className="modal-footer">
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              setModal(false);
                              validation.resetForm({});
                            }}
                          >
                            TUTUP
                          </button>

                          <button type="submit" className="btn btn-success" disabled={loading}>
                            <span className="d-flex align-items-center">
                              SIMPAN
                              {loading && (
                                <Spinner size="sm" className="flex-shrink-0" role="status">
                                  Loading...
                                </Spinner>
                              )}
                            </span>
                          </button>
                        </div>
                      </div>
                    </Form>
                  </Modal>
                  <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
                </CardBody>
              </Card>
            </Col>

            <Col lg={3}>
              <Card>
                <div className="card-body">
                  <table className="table align-middle table-nowrap mb-3">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" className="p-2 pt-3 pb-3">
                          Dokumen:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(info.image_3 || []).map((file, key) => {
                        let src;
                        return (
                          <tr
                            key={key + "filehak"}
                            className="cursor-pointer"
                            onClick={() => {
                              const typeFile = file.filename.split(".");
                              if (typeFile[typeFile.length - 1] === "x-compressed") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "sheet") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "pdf") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else {
                                //
                              }
                            }}
                          >
                            <td>
                              <div className="d-flex">
                                <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                  <span className="fs-18 text-info">{renderIcon(file.filename)}</span>
                                </div>
                                <div className="flex-grow-1 text-start">
                                  <p className="fw-semibold mb-1 mt-1">{file.description}</p>
                                  <p>{file.originalname}</p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <h6 className="fw-semibold mb-2">Keterangan</h6>
                  <p className="mb-4">{info?.description} </p>
                </div>
                <CardBody className="text-center">
                  {/* {locationCord !== undefined ||
                    (locationCord !== null && (
                      <MapContainer center={locationCord} zoom={12} style={{ height: "300px" }}>
                        <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                        <Marker position={locationCord}>
                          <Popup>{info.lf_branch && info.lf_branch.name ? info.lf_branch.name : "-"}</Popup>
                        </Marker>
                      </MapContainer>
                    ))} */}

                  <table className="table border table-responsive fs-13 mb-3">
                    <tbody>
                      <tr>
                        <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                          INFORMASI LAINNYA
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Perusahaan</td>
                        <td className="p-2">{info.lf_company && info.lf_company.name ? info.lf_company.name : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Dibuat Oleh</td>
                        <td className="p-2">{info.lf_createdby && info.lf_createdby.name ? info.lf_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Diedit Oleh</td>
                        <td className="p-2">{info.lf_updatedby && info.lf_updatedby.name ? info.lf_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal id="showModalAccPayable" isOpen={modalAccPayable} centered size="lg">
          <ModalHeader className="bg-light p-3" toggle={toggleAccPayable}>
            TAGIHAN {info?.name}
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validationAccPayable.handleSubmit();
              return false;
            }}>
            <ModalBody>
              <div className="row">
                <div className="mb-3 col-lg-4">
                  <Label htmlFor="amount-field" className="form-label">
                    Jumlah
                  </Label>
                  <CurrencyInput
                    id="amount"
                    name="amount"
                    prefix="Rp. "
                    style={{ border: "1px solid #ccc" }}
                    className="form-control product-price"
                    placeholder="Terbayar"
                    value={validationAccPayable.values.amount}
                    decimalsLimit={2}
                    onFocus={(e) => e.target.select()}
                    onValueChange={(value, name, values) => {
                      let amount = !isNaN(parseFloat(info.amount)) ? parseFloat(info.amount) : 0;
                      validationAccPayable.setFieldValue("amount", parseFloat(value));
                    }}
                  />
                  {validationAccPayable.touched.amount && validationAccPayable.errors.amount && <p className="invalid-feedback d-block" type="invalid">{validationAccPayable.errors.amount}</p>}
                </div>
                <div className="mb-3 col-lg-4">
                  <Label htmlFor="amount-field" className="form-label">
                    Tanggal Tagihan
                  </Label>
                  <Flatpickr
                    className="form-control"
                    id="datepicker-publish-input"
                    placeholder="Select transaction date"
                    options={{
                      mode: "single",
                      dateFormat: "Y/m/d",
                    }}
                    onChange={(selectedDates, dateStr) => {
                      validationAccPayable.setFieldValue("transactionat", dateStr);
                    }}
                    value={validationAccPayable.values.transactionat ?? ""} />
                </div>
                <div className="mb-3 col-lg-4">
                  <Label className="form-label">
                    Cashflow
                  </Label>
                  <Select
                    name="cashflow"
                    value={validationAccPayable.values.cashflow}
                    placeholder="Pilih Cashflow"
                    onChange={(e) => {
                      validationAccPayable.setFieldValue("cashflow", e);
                    }}
                    options={budgetList}></Select>
                  {validationAccPayable.touched.cashflow && validationAccPayable.errors.cashflow && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayable.errors.cashflow}
                    </small>
                  )}
                </div>
                <div className="mb-3">
                  <Label htmlFor="address-field" className="form-label">
                    Keterangan
                  </Label>
                  <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={3} value={validationAccPayable.values.description ?? ""} onBlur={validationAccPayable.handleBlur} onChange={validationAccPayable.handleChange} invalid={validationAccPayable.touched.description && validationAccPayable.errors.description ? true : false} />
                  {validationAccPayable.touched.description && validationAccPayable.errors.description && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayable.errors.description}
                    </small>
                  )}
                </div>
              </div>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalAccPayable(false);
                    validationAccPayable.resetForm();
                  }}>
                  Close
                </button>
                <button type="submit" className="btn btn-success">
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1 me-2">SIMPAN TAGIHAN</span>
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>
        <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
            {`View ${detailType}`}
          </ModalHeader>
          {info !== undefined && info !== null && (
            <>
              <PrintDocF4 innerRef={printRef} item={info} type={detailType} />
            </>
          )}

          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModalDetail(false);
                }}
              >
                TUTUP
              </button>
              {<ButtonPrintF4 innerRef={printRef} title={`${detailType}-${info?.nama ?? ""}`} />}
            </div>
          </div>
        </Modal>
      </div >
    </>
  );
};

export default withRouter(withTranslation()(LegalFraction));
